<template>
    <div class="single-ipad" :class="{ 'single-ipad--reverse': reverse, 'single-ipad--reverse-sm': reverseSM }">
        <div class="container">
            <div class="single-ipad__container">
                <div class="single-ipad__ipad">
                    <div class="ipad" :class="{ 'ipad--portrait': portrait, 'ipad--no-shadow': noShadow }">
                        <slot name="ipad" />
                    </div>
                </div>

                <div v-if="$slots.default" class="single-ipad__content">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        portrait: Boolean,
        reverse: Boolean,
        reverseSM: Boolean,
        noShadow: Boolean,
    },
};
</script>
